import store from '@/store/store';
import Amplify from '@aws-amplify/core';
import {Auth} from 'aws-amplify';

export const SSO_ORGANIZATION_CODE = 'customer_sso_organizationCode';


const dealWithError = function (error, source, next) {
  console.error(`error ${source}`, error);
  const status = error.status && error.status === 406 ? 'user_disabled' : 'default';

  next({
    name: 'sso-page-login-error',
    params: {
      status,
      error
    },
    replace: true
  });
};

export default {
  path: 'public',
  component: () => import('@/layouts/full-page/FullPage.vue'),
  meta: {
    public: true
  },
  children: [
    {
      path: 'error-404',
      name: 'page-error-404',
      meta: {
        public: true
      },
      component: () => import('@/views/pages/Error404.vue')
    },
    {
      path: '/maintenance',
      name: 'page-maintenance',
      meta: {
        public: true
      },
      component: () => import('@/views/pages/Maintenance.vue')
    },
    {
      path: '/landing/login',
      name: 'page-login',
      meta: {
        public: true
      },
      component: () => import('@/views/pages/Login.vue'),
      beforeEnter: async (to, from, next) => {
        const resource = await store.state.router.apiRoot.$request().$get('public');
        store.commit('router/updateRouteProp', {
          property: 'publicRoot',
          value: resource
        });
        next();
      },
      props: () => ({
        publicRoot: store.state.router.publicRoot
      })
    },
    {
      path: '/landing/federated_login',
      name: 'federated-page-login',
      meta: {
        public: true
      },
      component: () => import('@/views/pages/FederatedLogin.vue'),
      beforeEnter: async (to, from, next) => {
        const resource = await store.state.router.apiRoot.$request().$get('public');
        store.commit('router/updateRouteProp', {
          property: 'publicRoot',
          value: resource
        });
        next();
      },
      props: () => ({
        publicRoot: store.state.router.publicRoot,
        isLogoutPage: false
      })
    },
    {
      path: '/landing/federated_logout',
      name: 'federated-page-logout',
      meta: {
        public: true
      },
      component: () => import('@/views/pages/FederatedLogin.vue'),
      beforeEnter: async (to, from, next) => {
        const resource = await store.state.router.apiRoot.$request().$get('public');
        store.commit('router/updateRouteProp', {
          property: 'publicRoot',
          value: resource
        });
        next();
      },
      props: () => ({
        publicRoot: store.state.router.publicRoot,
        isLogoutPage: true
      })
    },
    {
      path: '/landing/activate',
      name: 'page-activate',
      meta: {
        public: true
      },
      component: () => import('@/views/pages/Activation.vue'),
      beforeEnter: async (to, from, next) => {
        const resource = await store.state.router.apiRoot.$request().$get('public');
        store.commit('router/updateRouteProp', {
          property: 'publicRoot',
          value: resource
        });
        next();
      },
      props: () => ({
        publicRoot: store.state.router.publicRoot
      })
    },
    {
      path: '/landing/forgotten_password',
      name: 'page-forgotten-password',
      meta: {
        public: true
      },
      component: () => import('@/views/pages/ForgottenPassword.vue'),
      beforeEnter: async (to, from, next) => {
        const resource = await store.state.router.apiRoot.$request().$get('public');
        store.commit('router/updateRouteProp', {
          property: 'publicRoot',
          value: resource
        });
        next();
      },
      props: () => ({
        publicRoot: store.state.router.publicRoot
      })
    },
    {
      path: '/landing/reset_password',
      name: 'page-reset-password',
      meta: {
        public: true
      },
      component: () => import('@/views/pages/ResetPassword.vue'),
      beforeEnter: async (to, from, next) => {
        const resource = await store.state.router.apiRoot.$request().$get('public');
        store.commit('router/updateRouteProp', {
          property: 'publicRoot',
          value: resource
        });
        next();
      },
      props: () => ({
        publicRoot: store.state.router.publicRoot
      })
    },
    {
      path: '/landing/configure_mfa',
      name: 'page-configure-mfa',
      meta: {
        public: true
      },
      component: () => import('@/views/pages/ConfigureMFA.vue'),
      beforeEnter: async (to, from, next) => {
        if (!to.params.cognitoUser) {
          next({ name: 'page-login' });
          return;
        }
        next();
      },
      props: true
    },
    {
      path: '/landing/sso_login/:organizationCode',
      name: 'sso-page-login',
      meta: {
        public: true
      },
      beforeEnter: async (to, from, next) => {
        const publicRoot = await store.state.router.apiRoot.$request().$get('public');
        store.commit('router/updateRouteProp', {
          property: 'publicRoot',
          value: publicRoot
        });

        localStorage.setItem(SSO_ORGANIZATION_CODE, to.params.organizationCode);
        publicRoot.$request().$get('sso_configuration', {organizationCode: to.params.organizationCode}).then(res => {

          const config = {
            Auth: {
              region: process.env.VUE_APP_COGNITO_REGION,
              userPoolId: process.env.VUE_APP_COGNITO_USER_POOL,
              userPoolWebClientId: process.env.VUE_APP_COGNITO_USER_POOL_WEB_CLIENT_ID,
              oauth: {
                domain: process.env.VUE_APP_COGNITO_IDP_DOMAIN,
                scope: ['email', 'profile', 'openid'],
                redirectSignIn: res.redirectSignIn,
                redirectSignOut: res.redirectSignOut,
                responseType: 'code'
              }
            }
          };
          Amplify.configure(config);
          Auth.federatedSignIn({provider: res.provider});
        }).catch(error => {
          dealWithError(error, 'configuration', next);
        });
      },
      props: () => ({
        publicRoot: store.state.router.publicRoot
      })
    },
    {
      path: '/landing/sso_login_error',
      name: 'sso-page-login-error',
      meta: {
        public: true
      },
      component: () => import('@/views/pages/SsoError.vue')
    },
    {
      path: '/landing/sso_login_finish',
      name: 'sso-page-login-finish',
      meta: {
        public: true
      },
      beforeEnter: async (to, from, next) => {
        const publicRoot = await store.state.router.apiRoot.$request().$get('public');
        store.commit('router/updateRouteProp', {
          property: 'publicRoot',
          value: publicRoot
        });

        const organizationCode = localStorage.getItem(SSO_ORGANIZATION_CODE);
        if (!organizationCode) {
          next({name: 'page-login'});
          return;
        }

        publicRoot.$request().$get('sso_configuration', {organizationCode}).then(res => {
          const config = {
            Auth: {
              region: process.env.VUE_APP_COGNITO_REGION,
              userPoolId: process.env.VUE_APP_COGNITO_USER_POOL,
              userPoolWebClientId: process.env.VUE_APP_COGNITO_USER_POOL_WEB_CLIENT_ID,
              oauth: {
                domain: process.env.VUE_APP_COGNITO_IDP_DOMAIN,
                scope: ['email', 'profile', 'openid'],
                redirectSignIn: res.redirectSignIn,
                redirectSignOut: res.redirectSignOut,
                responseType: 'code'
              }
            }
          };
          Amplify.configure(config);

          Auth.currentSession().then(session => {
            store.commit('account/setAccessToken', session.getAccessToken().getJwtToken());
            publicRoot.$request().$post('sign_in_federated', null, {
              username: session.getIdToken().payload['cognito:username'],
              email: session.getIdToken().payload.email,
              federatedIdpName: res.provider,
              givenName: session.idToken.payload.given_name,
              familyName: session.idToken.payload.family_name,
              rememberMe: true
            }).then(() => {
              store.state.router.apiRoot.$request().$getSelf().then(root => {
                store.commit('router/updateRouteProp', {
                  property: 'apiRoot',
                  value: root
                });
                next({
                  name: 'app-dashboard',
                  replace: true
                });
              });
            }).catch(err => {
              dealWithError(err, 'sign_in error handler', next);
            });
          }, err => {
            dealWithError(err, 'errorHandler', next);
          }).catch(err => {
            dealWithError(err, 'catch', next);
          });
        });
      },
      props: () => ({
        publicRoot: store.state.router.publicRoot
      })
    },
    {
      path: '/landing/sso_logout',
      name: 'sso-page-logout',
      meta: {
        public: true
      },
      component: () => import('@/views/pages/SsoLogout.vue'),
      beforeEnter: async (to, from, next) => {
        const resource = await store.state.router.apiRoot.$request().$get('public');
        store.commit('router/updateRouteProp', {
          property: 'publicRoot',
          value: resource
        });
        next();
      },
      props: () => ({
        publicRoot: store.state.router.publicRoot
      })
    }
  ]
};
